import React, { useState } from 'react';
import css from './ReviewCard.module.css';
import user from './user.png'
import moment from 'moment';
import { charLimit } from '../../util/charLimit';
import { BottleRatingReview } from '../review/Bottle';
import {AiOutlineEdit } from 'react-icons/ai'
import {MdDeleteOutline } from 'react-icons/md'
import NamedLink from '../NamedLink/NamedLink';

const ReviewCard = ({
  review,
  setUpdateModalOpen,
  setReviewToUpdate,
  setOpenDeleteModal,
  setReviewToDelete,
  action = false,
  isProfile = false,
}) => {
  const imgSrc = review?.user.image !== undefined ? review?.user.image : user;
  const [charLimit, setChatLimit] = useState(150);
  return (
    <div key={review?._id} className={css.vineyardReviewsCard}>
      <div>
        {isProfile && review ? (
          <div className={css.vineyardReviewsCardHeader}>
            <NamedLink name="Winery" params={{slug: review?.winery.slug, id: review?.winery._id}}>
              <h4>{review?.winery.name}</h4>
            </NamedLink>
          </div>
        ) : (
          <div className={css.vineyardReviewsCardHeader}>
            <img src={imgSrc} alt="" />
            <div className={css.vineyardReviewsCardInfo}>
              <NamedLink name="ProfilePage" params={{id: review?.user.sharetribeUserId }}>
                <h4>{review?.user.firstName} {review?.user.lastName}</h4>
              </NamedLink>
              <div style={{display: 'flex', alignItems: "center", justifyContent: "space-between"}}>
                <h6>{review?.user.iam}</h6>
                {/* <span>145 Reviews</span> */}
              </div>
            </div>
          </div>
        )}

        <div className={css.vineyardReviewsCardBody}>
          <p>{review?.description.length >= charLimit ? (
            <span>
              {review?.description.slice(0, charLimit)}...
              {charLimit === review?.description.length ? (
                <span
                  style={{color: "var(--burgundy)", cursor: "pointer"}}
                  onClick={() => setChatLimit(150)}
                >
                  Read Less
                </span>
              ) : (
                <span
                  style={{color: "var(--burgundy)", cursor: "pointer"}}
                  onClick={() => setChatLimit(review?.description.length)}
                >
                  Read More
                </span>
              ) }

            </span>
          ) : review?.description}</p>
        </div>
      </div>
      <div className={css.vineyardReviewsCardFooter}>
        <span>{moment(review?.createdAt).format('ll')}</span>
        <div>
          <BottleRatingReview score={review?.score} uniqId={review?._id} />
        </div>
      </div>

      {action ? (
        <div className={css.actionBtns}>
          <AiOutlineEdit
            onClick={() => {
              setUpdateModalOpen(true);
              setReviewToUpdate(review)
            }}
            style={{color: 'rgb(43, 47, 104)', marginRight:"6px", cursor: 'pointer'}}
          />
          <MdDeleteOutline
            onClick={()=> {
              setOpenDeleteModal(true);
              setReviewToDelete(review);
            }}
            style={{color: 'rgb(120, 38, 79)', cursor: 'pointer'}}
          />
        </div>
      ) : null}
    </div>
  )
}

export default ReviewCard
